module.exports = __webpack_public_path__ + "img/experience.04c54735.svg";